export default "__VITE_ASSET__DKm9gKc9__"